import { ERROR_CODES } from 'api/error-handling/error-codes';
import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthleteKiloClass, AthleteKiloClassWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAthleteClass(): UseMutationResult<
  AxiosResponse<AthleteKiloClass>,
  AxiosError<ErrorMessage>,
  AthleteKiloClassWrite
> {
  const queryClient = useQueryClient();

  const updateAthleteClass = (
    athleteKiloClass: AthleteKiloClassWrite,
  ): Promise<AxiosResponse<AthleteKiloClass>> => {
    return client.put(`athlete-kilo-classes/${athleteKiloClass?.athleteKiloClassId}/`, athleteKiloClass);
  };

  const invalidateAthleteClassQueries = (): void => {
    queryClient.invalidateQueries({
      queryKey: ['athleteClasses'],
    });
    queryClient.invalidateQueries({
      queryKey: ['athleteEvents'],
    });
    queryClient.invalidateQueries({
      queryKey: ['classes'],
    });
    queryClient.invalidateQueries({
      queryKey: 'events',
    });
    queryClient.invalidateQueries({
      queryKey: ['totalAttended'],
    });
    queryClient.invalidateQueries({
      queryKey: ['totalReserved'],
    });
  };

  return useMutation(updateAthleteClass, {
    onSuccess: () => {
      invalidateAthleteClassQueries();
    },
    onError: (error: AxiosError<ErrorMessage>) => {
      // If it's a no-op error (NO_STATE_CHANGE), invalidate cache to ensure data is refreshed
      const errorCode = error.response?.data?.errorCode;
      if (errorCode === ERROR_CODES.COMMON.NO_STATE_CHANGE) {
        invalidateAthleteClassQueries();
      }
    },
  });
}
